import type { ComponentType } from "react";
import { DecisionWorkspace, ValueLedger } from "./lng/LNGDecisionFlow";
import Opportunities from "./lng/Opportunities";
import { HedgeWorkspace, PlanningWorkspace } from "./lng/LNGBlockWorkspaces";
import ExecutiveCompliance from "./lng/ExecutiveCompliance";
import { ProcurementWorkspace, TransportWorkspace, ClearanceWorkspace, FulfilmentWorkspace } from "./lng/SupplyChainInsights";
import { CommercialRisk, ContractPlanning, CommercialSales, SupplierProcurement, CommodityHedgeControl, CurrencyHedgeControl } from "./lng/CommercialControls";
import SignalsPredictions from "./lng/SignalsPredictions";
import { CustomerInvoices, SupplierInvoices } from "./lng/FinanceAccounting";
import TreasurySimulation, { CommodityFormulaTime, RegionDestinationPortfolio, FreightVesselLogistics, CurrencyLiquidityCash } from "./lng/TreasurySimulation";
import { Governance, Audit, CarbonEmissions, ThreatDetectionCoverage, ActiveAlertsAnomalies, OtProtocolAnomalyRate, EdrXdrCoverage, MeanTimeToDetect, SiemCorrelationScore, NetworkThreatScore, CentralizedLogIngestion } from "./lng/ComplianceAudit";
import { OperationsOverview, SourceHealth } from "./ops/Operations";
import { OperationsExceptions } from "./ops/Exceptions";

function ScreenUnavailable() {
  return <section className="netiv-session-state" role="alert">Screen unavailable.</section>;
}
export const SCREENS: Record<string, Record<string, ComponentType>> = {
  executive: { decisions: DecisionWorkspace, "value-ledger": ValueLedger, "executive-compliance": ExecutiveCompliance },
  business: {
    "signals-predictions": SignalsPredictions, opportunities: Opportunities, "risk-analysis": CommercialRisk,
    "contract-planning": ContractPlanning, sales: CommercialSales, "supplier-procurement": SupplierProcurement,
    "commodity-hedge": CommodityHedgeControl, "currency-hedge": CurrencyHedgeControl, planning: PlanningWorkspace,
    hedge: HedgeWorkspace, procurement: ProcurementWorkspace, treasury: TreasurySimulation,
    "treasury-commodity": CommodityFormulaTime, "treasury-region": RegionDestinationPortfolio,
    "treasury-freight": FreightVesselLogistics, "treasury-currency": CurrencyLiquidityCash,
    transport: TransportWorkspace, clearance: ClearanceWorkspace, fulfilment: FulfilmentWorkspace,
    "finance-accounting": CustomerInvoices, "finance-customer": CustomerInvoices, "finance-supplier": SupplierInvoices,
  },
  compliance: {
    governance: Governance, audit: Audit, "carbon-emissions": CarbonEmissions, security: ThreatDetectionCoverage,
    "security-threat-coverage": ThreatDetectionCoverage, "security-active-alerts": ActiveAlertsAnomalies,
    "security-ot-anomaly": OtProtocolAnomalyRate, "security-edr-xdr": EdrXdrCoverage, "security-mttd": MeanTimeToDetect,
    "security-siem": SiemCorrelationScore, "security-threat-score": NetworkThreatScore, "security-log-ingestion": CentralizedLogIngestion,
  },
  maintenance: { "maintenance-overview": OperationsOverview, "maintenance-source-health": SourceHealth, "maintenance-alerts": OperationsExceptions },
};
export function getScreen(roleId: string, screenId: string): ComponentType {
  return SCREENS[roleId]?.[screenId] ?? ScreenUnavailable;
}
